import {Duration} from '../../../Domain/Duration';

function pad(number: number, length = 2): string {
    let str = `${number}`;
    while (str.length < length) {
        str = `0${str}`;
    }
    return str;
}

export function formatTime(time: Duration): {formatted: string; unit?: string} {
    const hundreds = Math.ceil(time.milliseconds / 10);
    const millisecondsRounded = hundreds * 10;

    //Format time with milliseconds if it's less than 1 hour and with seconds if it's more than 1 hour
    const hours = Math.floor(millisecondsRounded / 3600000);
    const minutes = Math.floor(millisecondsRounded / 60000) % 60;
    const seconds = Math.floor(millisecondsRounded / 1000) % 60;
    const milliseconds = millisecondsRounded % 1000;
    const hundredths = Math.floor(milliseconds / 10);

    if (hours > 0) {
        return {formatted: `${hours}:${pad(minutes)}:${pad(seconds)}`};
    }

    return {formatted: `${pad(minutes)}:${pad(seconds)}.${pad(hundredths)}`};
}
